import { useEffect } from 'react';
import { Route, Routes, useParams } from 'react-router-dom';
import { useBrandContext } from '../../../contexts/BrandContext/BrandContext';
import { useCuisinesContext } from '../../../contexts/CuisinesContext';
import BrandBasicInfoPage from './BrandBasicInfoPage';
import BrandAboutPage from './BrandAboutPage';
import BrandLocationPage from './BrandLocationPage';
import BrandCoverAreaPage from './BrandCoverAreaPage';
import BrandLogoPage from './BrandLogoPage';
import BrandSocialsPage from './BrandSocialsPage';
import BrandMediaPage from './BrandMediaPage';
import BrandProfilePage from '../BrandProfilePage';
import BrandGiftCardsPage from './BrandGiftCardsPage';
import BrandGalleryPage from './BrandGalleryPage';
import BrandFaqsPage from './BrandFaqsPage';
import BrandFaqFormPage from './BrandFaqFormPage';

const BrandEditorContent = () => {
  const { brandId } = useParams<{ brandId: string }>();
  const { currentBrand, setBrand } = useBrandContext();
  const { loadCuisines } = useCuisinesContext();

  useEffect(() => {
    if (brandId && currentBrand?.id !== brandId) {
      setBrand(brandId);
    }
  }, [brandId, currentBrand?.id, setBrand]);

  useEffect(() => {
    loadCuisines();
  }, [loadCuisines]);

  if (!currentBrand || currentBrand.id !== brandId) return null;

  return (
    <Routes>
      <Route index element={<BrandProfilePage />} />
      <Route path="basic" element={<BrandBasicInfoPage />} />
      <Route path="about" element={<BrandAboutPage />} />
      <Route path="location" element={<BrandLocationPage />} />
      <Route path="cover" element={<BrandCoverAreaPage />} />
      <Route path="logo" element={<BrandLogoPage />} />
      <Route path="gallery" element={<BrandGalleryPage />} />
      <Route path="social" element={<BrandSocialsPage />} />
      <Route path="media" element={<BrandMediaPage />} />
      <Route path="gift-cards" element={<BrandGiftCardsPage />} />
      <Route path="faqs" element={<BrandFaqsPage />} />
      <Route path="faqs/:faqId" element={<BrandFaqFormPage />} />
    </Routes>
  );
};

const BrandEditor = () => <BrandEditorContent />;

export default BrandEditor;
